__turbopack_context__.v({
  "chip": "OjX8ja_chip",
  "chips": "OjX8ja_chips",
  "dots": "OjX8ja_dots",
  "list": "OjX8ja_list",
  "more": "OjX8ja_more",
  "moreCount": "OjX8ja_moreCount",
  "rail": "OjX8ja_rail",
  "railCount": "OjX8ja_railCount",
  "railHeading": "OjX8ja_railHeading",
  "railName": "OjX8ja_railName",
  "slide": "OjX8ja_slide",
  "track": "OjX8ja_track",
});
